import React from 'react'

import ExpandablePanel from '../controls/ExpandablePanel'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import { controlHasError } from '../../lib/errorHandler'

class Adres extends React.Component {
  state = {
    wojewodztwa: [
      'DOLNOŚLĄSKIE',
      'KUJAWSKO-POMORSKIE',
      'LUBELSKIE',
      'LUBUSKIE',
      'ŁÓDZKIE',
      'MAŁOPOLSKIE',
      'MAZOWIECKIE',
      'OPOLSKIE',
      'PODKARPACKIE',
      'PODLASKIE',
      'POMORSKIE',
      'ŚLĄSKIE',
      'ŚWIĘTOKRZYSKIE',
      'WARMIŃSKO-MAZURSKIE',
      'WIELKOPOLSKIE',
      'ZACHODNIOPOMORSKIE',
    ],
  }

  render() {
    return (
      <ExpandablePanel title="ADRES">
        <form autoComplete="off" className="adres">
          <div className="firstRow">
            <FormControl component="fieldset">
              <InputLabel>Województwo</InputLabel>
              <Select
                error={controlHasError(this.props.errors, 'Wojewodztwo')}
                name="Wojewodztwo"
                value={this.props.data.Wojewodztwo}
                onChange={e =>
                  this.props.onSetSectionData(e.target.name, e.target.value)
                }
              >
                {this.state.wojewodztwa.map(w => (
                  <MenuItem key={w} value={w}>
                    {w.toLocaleLowerCase()}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl component="fieldset">
              <TextField
                error={controlHasError(
                  this.props.errors,
                  'Powiat',
                  this.props.data.Powiat,
                )}
                name="Powiat"
                label="Powiat"
                title={this.props.data.Powiat}
                value={this.props.data.Powiat}
                onChange={e =>
                  this.props.onSetSectionData(e.target.name, e.target.value)
                }
              />
            </FormControl>
            <FormControl component="fieldset">
              <TextField
                error={controlHasError(
                  this.props.errors,
                  'Gmina',
                  this.props.data.Gmina,
                )}
                name="Gmina"
                label="Gmina"
                title={this.props.data.Gmina}
                value={this.props.data.Gmina}
                onChange={e =>
                  this.props.onSetSectionData(e.target.name, e.target.value)
                }
              />
            </FormControl>
          </div>
          <div className="secondRow">
            <FormControl component="fieldset">
              <TextField
                error={controlHasError(this.props.errors, 'Ulica')}
                name="Ulica"
                label="Ulica"
                title={this.props.data.Ulica}
                value={this.props.data.Ulica}
                onChange={e =>
                  this.props.onSetSectionData(e.target.name, e.target.value)
                }
              />
            </FormControl>

            <FormControl component="fieldset">
              <TextField
                error={controlHasError(this.props.errors, 'NrDomu')}
                name="NrDomu"
                label="Nr domu"
                title={this.props.data.NrDomu}
                value={this.props.data.NrDomu}
                onChange={e =>
                  this.props.onSetSectionData(e.target.name, e.target.value)
                }
              />
            </FormControl>

            <FormControl component="fieldset">
              <TextField
                error={controlHasError(this.props.errors, 'NrLokalu')}
                name="NrLokalu"
                label="Nr lokalu"
                title={this.props.data.NrLokalu}
                value={this.props.data.NrLokalu}
                onChange={e =>
                  this.props.onSetSectionData(e.target.name, e.target.value)
                }
              />
            </FormControl>
          </div>

          <div className="thirdRow">
            <FormControl component="fieldset">
              <TextField
                error={controlHasError(
                  this.props.errors,
                  'Miejscowosc',
                  this.props.data.Miejscowosc,
                )}
                name="Miejscowosc"
                label="Miejscowość"
                title={this.props.data.Miejscowosc}
                value={this.props.data.Miejscowosc}
                onChange={e =>
                  this.props.onSetSectionData(e.target.name, e.target.value)
                }
              />
            </FormControl>

            <FormControl component="fieldset">
              <TextField
                error={controlHasError(this.props.errors, 'KodPocztowy')}
                name="KodPocztowy"
                label="Kod pocztowy"
                title={this.props.data.KodPocztowy}
                value={this.props.data.KodPocztowy}
                onChange={e =>
                  this.props.onSetSectionData(e.target.name, e.target.value)
                }
              />
            </FormControl>

            <FormControl component="fieldset">
              <TextField
                error={controlHasError(this.props.errors, 'Poczta')}
                name="Poczta"
                label="Poczta"
                title={this.props.data.Poczta}
                value={this.props.data.Poczta}
                onChange={e =>
                  this.props.onSetSectionData(e.target.name, e.target.value)
                }
              />
            </FormControl>

            <FormControl component="fieldset">
              <TextField
                error={controlHasError(this.props.errors, 'KodKraju')}
                name="KodKraju"
                label="Kod kraju"
                title={this.props.data.KodKraju}
                value={this.props.data.KodKraju}
                onChange={e =>
                  this.props.onSetSectionData(e.target.name, e.target.value)
                }
              />
            </FormControl>
          </div>
        </form>
      </ExpandablePanel>
    )
  }
}

export default Adres
